import React, { Component } from 'react';
// import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Icons from '../../Components/Icons/Icons';
import {dismissActivityReminderDetails,getActivityReminderDetails,getUserTimeZone } from '../../Utils/UserFunctions';
import IconClose2 from '../../Components/Icons/IconsList/IconClose2';

class ReminderPopup extends Component {
	constructor(props) {
		super(props);
		this.reminderInterval = null;
		this._handledReminderTime = null; // 'YYYY-MM-DDTHH:mm'
		this._handledReminderKeys = new Set();
		this._didRefreshForHandledTime = false;
		this.state = {
			reminderDetails:{
				key:null,
				display:false,
			}
		}
	}
	
	componentDidMount() {
		getActivityReminderDetails();
		this.reminderInterval = setInterval(() => {
			this.reminderSetTimeInterval();
		}, 1000);
		window.addEventListener('reminder-fire', this.handleFireTimeReminder);
	}

	componentWillUnmount() {
		if (this.reminderInterval) {
			clearInterval(this.reminderInterval);
			this.reminderInterval = null;
		}
		window.removeEventListener('reminder-fire', this.handleFireTimeReminder);
	}

	/**
	 * Quartz fire-time SSE: show from payload so every tab pops without racing
	 * reminders/list (NextFireTime already moved after the job fired).
	 * Dedupes against the per-minute poll path so we don't double-show.
	 */
	handleFireTimeReminder = (event) => {
		const data = event && event.detail;
		if (!data || !data.id) {
			return;
		}
		const alertType = data.remind_alert;
		if (alertType !== 1 && alertType !== 2) {
			return;
		}

		const currentTime = moment().tz(getUserTimeZone()).format('YYYY-MM-DDTHH:mm');
		if (this._handledReminderTime !== currentTime) {
			this._handledReminderTime = currentTime;
			this._handledReminderKeys = new Set();
			this._didRefreshForHandledTime = false;
		}
		if (this._handledReminderKeys.has(data.id)) {
			return;
		}
		this._handledReminderKeys.add(data.id);

		this.setState({
			reminderDetails: {
				...data,
				DisplayText: data.DisplayText || { data: 'You have a reminder' },
				display: true,
				key: data.id,
			},
		});
	};

	render() {
		
		// console.log("showItems------",showItems);
		const {reminderDetails} = this.state;
		return (	
			<ReminderPopupSneeze 
				closeSnoozeHandler={this.closeSnoozeHandler}
				snoozeHandler={this.snoozeHandler}
				dismissHandler={this.dismissHandler}
				reminderDetails={reminderDetails} />
		);
	}

	// REMINDER METHOD
	reminderSetTimeInterval = ()=>{
		let ACTIVITY_REMINDER = localStorage.getItem('ACTIVITY_REMINDER');
		// console.log(ACTIVITY_REMINDER);
		if(ACTIVITY_REMINDER!==null && ACTIVITY_REMINDER!==undefined){
			ACTIVITY_REMINDER =JSON.parse(ACTIVITY_REMINDER);
			const currentTime = moment().tz(getUserTimeZone()).format('YYYY-MM-DDTHH:mm');
			if (this._handledReminderTime !== currentTime) {
				this._handledReminderTime = currentTime;
				this._handledReminderKeys = new Set();
				this._didRefreshForHandledTime = false;
			}

			let shouldRefresh = false;
			Object.entries(ACTIVITY_REMINDER).map(([key, remind]) => {
				// console.log(currentTime,remind.NextFireTime,this.state.reminderDetails);
				if(remind.NextFireTime===currentTime && !this._handledReminderKeys.has(key)){ // handled once per due-minute
					this._handledReminderKeys.add(key);
					// if(key==='8f35f6dc-445d-4fa4-b431-82af6f335466' && reminderDetails.key!=='8f35f6dc-445d-4fa4-b431-82af6f335466'){	
					if(remind.remind_alert===1|| remind.remind_alert===2){
						this.setState({reminderDetails:{...remind,display:true,key:key}});
					}
					shouldRefresh = true;
				}
			})

			// Only refresh once per due-minute even if multiple reminders are due.
			if (shouldRefresh && this._didRefreshForHandledTime === false) {
				this._didRefreshForHandledTime = true;
				getActivityReminderDetails();
			}
		}
	  }
	  snoozeHandler = ()=>{
		const {reminderDetails} = this.state;
		reminderDetails.display = false;
		this.setState({reminderDetails:reminderDetails});
		setTimeout(() => {
			reminderDetails.display = true;
			this.setState({reminderDetails:reminderDetails});
		}, 60000);
		
	  }
	  closeSnoozeHandler = ()=>{
		const {reminderDetails} = this.state;
		reminderDetails.display = false;
		this.setState({reminderDetails:reminderDetails});
	  }
	  dismissHandler = (e,remidId)=>{
		const {reminderDetails} = this.state;
		reminderDetails.display = false;
		this.setState({reminderDetails:reminderDetails});
	   dismissActivityReminderDetails(remidId);
	}
	//REMINDER BLOCK END
} 

  export default (ReminderPopup);


   const ReminderPopupSneeze = (props)=>{
	const {reminderDetails} = props;
	// console.log(reminderDetails);
	  if(reminderDetails.display===true){
	return(
		  <div className="snoozeOuter">
			  {/* <!-- snooze box --> */}
				  <div className="snoozeBox alert animated fadeInUp">
					  <div className="border-bottom d-flex justify-content-between align-items-center p-2">
						  <div className="text-default"> 
							  <h4 className="mb-0 d-flex align-items-center"> 
								  <Icons iconType="PopupReminder" /> 
								  
								  {`Reminder`} 
							  </h4>
						  </div> 
						{(reminderDetails.OnlyDisplayText===true)?
						  <a onClick={()=>props.closeSnoozeHandler()}>
								<IconClose2 />
							  </a> : ""}
					  </div>
	 
					  <div className="card-body bg-body">
						  {Object.entries(reminderDetails.DisplayText || {}).map(([key, text]) => {
							  const href = "/layouts/"+reminderDetails.WindowName+"/"+reminderDetails.WindowId+"/detailView/"+reminderDetails.LayoutId+"/"+reminderDetails.MetatableId;
							  
							  return (
								  // <span>{key}:</span>
								  <div>
									  {(reminderDetails.OnlyDisplayText===false && reminderDetails?.WindowName)?
									  	<Link to={href} className="secondary_color">
										  {(key!=='record_id')?
											  <span>{text}</span>
										  :''}
									  	</Link>
									  :
									  	<span  className="secondary_color">
										  {(key!=='record_id')?
											  <span>{text}</span>
										  :''}
									  	</span>
									  }
									  
									  
									  
								  </div>
							  )
						  })}
					  </div>
						  {(reminderDetails.OnlyDisplayText===false)?
						  	<div className="card-footer bg-body p-2 d-flex justify-content-between">
							  <span className="text-success text-medium cursor-pointer" onClick={props.snoozeHandler}> Snooze  </span>
							  <span className="text-danger text-medium cursor-pointer" onClick={e=>props.dismissHandler(e,reminderDetails.key)}> Dismiss </span> 
						  </div>
						  :''}
					  
	 
				  </div>
				  {/* <!-- snooze box --> */}
			 
			 </div>
	  )
	  }else{
		  return(<div></div>)
	  }
  }